// extracted by mini-css-extract-plugin
export default {"styles":"lVsF10uFUR3TpjBImKZQ"};